import React, { useState } from 'react';
import { useQuery } from 'react-query';
import Loading from 'components/common/loading';
import { useSelector } from 'react-redux';
import { vmDropDownItems } from 'components/manage-vm/utils';
import { userRights } from 'store/selectors/user-details';
import { CustomHook } from 'utils/custom-hook';
import WhInstance from './WhInstance';
import { managerWhSortBy } from 'components/wh/instance/util';
import { MANAGE_WH } from './queries';
import { navLinks } from 'utils/nav-links-util';

const WhInstanceContainer = ({ refetchMenu }) => {
  const { paginationToUrl, getParams, per_page } = CustomHook();
  const rights = useSelector(userRights);
  const sort_by = getParams.sort_by || managerWhSortBy[0].value;
  const [queries, setQueries] = useState({
    page_number: getParams.page_number || 1,
    per_page: getParams.per_page || per_page,
    sort_by,
  });
  const {
    data: whData,
    isLoading,
    refetch: managerWhRefetch,
    isFetching: managerWhIsFetching,
  } = useQuery(['MANAGE_WH', queries], MANAGE_WH, {
    onSuccess: (res) => {
      paginationToUrl(navLinks.wh_instance.link, +res?.meta?.page, queries.sort_by, +res?.meta?.per_page);
    },
  });

  if (isLoading) {
    return <Loading gap={200} />;
  }
  return (
    <WhInstance
      whData={whData}
      setQueries={setQueries}
      queries={queries}
      managerWhRefetch={managerWhRefetch}
      managerWhIsFetching={managerWhIsFetching}
      dropdownItems={vmDropDownItems(rights, refetchMenu)}
      isLoading={isLoading}
    />
  );
};

export default WhInstanceContainer;
